import { ServiceMaker, methods, services } from "../services";


export const customerExport = (payload) =>
    ServiceMaker(`/cap/users/customer/export?page=${payload.page}&limit=${payload.limit}`, methods.GET, services.master);